import { Component, OnInit, ViewChild, Inject, ChangeDetectorRef, Input, HostListener, OnDestroy, Optional } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BsoSpecialInstructions, ClientList, UpdatePrehold } from '@EfsModels/efs.model';
import { saveAs } from 'file-saver';
// import { ReusableTableComponent } from '@EfsReusable/reusable-table/reusable-table.component';
import { EfsApiService } from '@EfsServices/efs-api.service';
import { LoggingService } from '@EfsServices/logging.service';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { GuardLinkService } from '@EfsServices/guard-link.service';
import { DataSharingService } from '@EfsServices/data-sharing.service';
import { SessionTimerService } from '@EfsServices/session-timer.service';
import { ApiErrorHandlingService } from '@EfsServices/api-error-handling.service';

import { ReusableTableComponent, TypeaheadSearchComponent, CorpSearchComponent } from '@nextgen/components-lib';
import { Subject } from 'rxjs';

import { environment } from '@efsEnvironments/environment';

@Component({
  selector: 'app-common-list-corps',
  templateUrl: './common-list-corps.component.html',
  styleUrls: ['./common-list-corps.component.css'],
  standalone: false
})
export class CommonListCorpsComponent implements OnInit, OnDestroy {

  viewOnlyMode = false;
  hideLoader = false;
  hidePage = true;

  // receive the module name from the component that calls this component
  moduleName = '';
  moduleTitle = '';
  @ViewChild('table0', { static: true }) reusableTable0: ReusableTableComponent;
  @ViewChild('table1', { static: true }) reusableTable1: ReusableTableComponent;
  @ViewChild('search0', { static: true }) searchComponent: TypeaheadSearchComponent;
  @ViewChild('fromCorp', { static: true }) fromCorpComponent: CorpSearchComponent;
  @ViewChild('toCorp', { static: true }) toCorpComponent: CorpSearchComponent;
  public tableEventSubject: Subject<any> = new Subject<any>();
  public table1EventSubject: Subject<any> = new Subject<any>();
  public clientEventSubject: Subject<any> = new Subject<any>();
  public fromEventSubject: Subject<any> = new Subject<any>();
  public toEventSubject: Subject<any> = new Subject<any>();
  message;
  searchMessage;
  messageObject;
  componentRef;
  popupDialogRef;

  loadingCorpsBanner = false;
  searchButtonDisable = false;
  savingCorpsBanner = false;

  searchComponentMessage = '';

  checkboxHeader = '\u00a0\u00a0';
  pageSizeOptions = [25, 50, 75];

  table0rowData;
  table1rowData;

  assocFilterControl = new UntypedFormControl('');

  facilityControl = new UntypedFormControl('');
  faciliyDisabled = true;
  toggleAllSelected = false;
  facilitiesToHold = [];
  filteredFacilities: any = [];
  facilityCds = [];
  facilityIds = [];
  selectedFacilityId = 'null'; // default value
  facilityIdSearchValue = 'null'; // default value for all facilities
  allSelectedValue = [{ name: 'All Selected' }];

  // get the non generic data and make it generic
  // rowData = {
  //   templateId: '',
  //   templateDesc: '',
  //   bsoTemplateDetailList: [],
  // };

  searchJson = {
    templateId: '',
    associatedCorps: [],
    targetClientId: 'null',
    disAssociatedFromCorpCd: '',
    disAssociatedToCorpCd: '',
    facilityId: 'null',
  };
  updateListCorps = {
    templateId: '',
    description: '',
    detailsAdded: [],
    detailsRemoved: [],
    detailsUpdated: [],
    corpsAdded: [],
    corpsRemoved: [],
    facilitiesAdded: [],
    facilitiesRemoved: [],
  };

  clients: ClientList[] = [];
  bsoTemplateDetailList;
  bsoTemplateDetailListCopy;
  bsoCodeAssocIds = [];
  fromCorp = 'null';
  toCorp = 'null';
  availCorpsTable = [];
  assocCorpsTable = [];

  hasSearchOccured = false;
  saveOccured = false;
  saveStatus = false;

  toggleSaveButton = true;
  toggleDiscButton = false;
  toggleAsscButton = false;
  showXButton = true;
  disableExport = false;

  effectiveDate;
  fromCorpValue;
  toCorpValue;
  clientId = 'null';
  searchClientId = null;
  clientName;
  clientNameDisp = '';
  fromCorpDisp;
  toCorpDisp;
  templateDesc;
  statesToHold;
  @Input() templateData = { templateDesc: '', statesToHold: [] }; // when not a popup, get data from parent

  // list of assigned facilities
  assignedFacilitiesToCorpsList = [];

  // define the columns in the table
  columns = [
    { columnDef: 'select', header: 'S', cell: (element: any) => `${element.select}` },

    { columnDef: 'blnktSlsOrderCd', header: 'Corp', cell: (element: any) => `${element.blnktSlsOrderCd}` },
    { columnDef: 'facilityCd', header: 'Facility', cell: (element: any) => `${element.facilityCd}` },
    { columnDef: 'blnktSlsOrderDesc', header: 'Description', cell: (element: any) => `${element.blnktSlsOrderDesc}` },
    { columnDef: 'clientNm', header: 'Client', cell: (element: any) => `${element.clientNm}` },
  ];
  displayedColumns = this.columns.map(c => c.columnDef);

  columns1 = [
    { columnDef: 'select', header: 'S', cell: (element: any) => `${element.select}` },

    {
      columnDef: 'blnktSlsOrderCd',
      header: 'Corp', cell: (element: any) => `${element.blnktSlsOrderCd}`
    },
    { columnDef: 'facilityCd', header: 'Facility', cell: (element: any) => `${element.facilityCd}` },
    {
      columnDef: 'blnktSlsOrderDesc',
      header: 'Description', cell: (element: any) => `${element.blnktSlsOrderDesc}`
    },
    {
      columnDef: 'clientNm', header: 'Client',
      cell: (element: any) => `${element.clientNm}`
    },
    {
      columnDef: 'templateDesc', header: 'Template', // columnDef: 'TemplateName'
      cell: (element: any) => `${element.templateDesc}`
    },
  ];
  displayedColumns1 = this.columns1.map(c => c.columnDef);

  constructor(
    private dataSharingService: DataSharingService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    // private componentFactoryResolver: ComponentFactoryResolver,
    private efsApiService: EfsApiService,
    private loggingService: LoggingService,
    @Optional() public dialogRef: MatDialogRef<CommonListCorpsComponent>,
    public dialog: MatDialog,
    private guardLinkService: GuardLinkService,
    private sessionTimerService: SessionTimerService,
    private apiErrorHandlingService: ApiErrorHandlingService,
    private ref: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.loadTableComponent();
    // listen for close requests from the main app
    const channel = new BroadcastChannel('commonListCorps');
    channel.postMessage('ListCorpsLoaded');
    channel.onmessage = ((message) => {
      console.log('received from main app ' + JSON.stringify(message.data));
      if (message.data === 'closeTab') { // SEND CLOSE IF TRYING TO OPEN TOO MANY
        console.log('closeTab received, close window');
        this.cancelButton();
        return;
      } else {
        this.data = message.data;
        console.log('what is data? ' + JSON.stringify(this.data));
      }
      this.moduleTitle = this.data.moduleTitle;
      this.moduleName = this.data.moduleName;
      // set view only mode
      if (this.data.viewOnlyMode === true) {
        // grey out the buttons when in this mode
        document.getElementById('exportButton').style.background = '#808080'; // turns button grey
        this.disableExport = true;

        this.reusableTable0.matTooltip = ''; // no tooltip for view only mode
        this.viewOnlyMode = true;
        this.searchComponent.searchControl.disable();
        this.fromCorpComponent.fromCorpControl.disable();
        this.toCorpComponent.toCorpControl.disable();
      } else {
        this.viewOnlyMode = false;
      }

      // now that it is loaded, do all the setup
      this.loggingService.logInfo('user is in list corps setup');
      try {
        this.showXButton = this.data.popUp;
      } catch {
        console.log('Not a popup');
      }
      console.log('LIST CORPS ' + JSON.stringify(this.data.templateData));
      // data is not generic, use a filter to treat the data generically until it needs to be consumed by a service,
      // at which point it will be re-identified. this will be based on the moduleName variable
      this.genericizeData();
      console.log(JSON.stringify(this.data.templateData));

      this.setValues();
      this.loadToCorpComponent();
      this.serviceGetFacilities();
      this.filterAssocCorps();

      // if (this.templateData.templateDesc !== '') { // set data if not a popup
      //   console.log('TEMPLATE DATA FROM PARENT ' + JSON.stringify(this.templateData));
      //   this.templateDesc = this.templateData.templateDesc;
      //   this.statesToHold = this.templateData.statesToHold.join(', ');
      //   this.data.templateData.templateId = sessionStorage.getItem('templateId');
      //   this.updateListCorps.templateId = sessionStorage.getItem('templateId');
      // }

      // this.serviceGettemplateCorps(); // now launched at service get facilities
      // this.serviceDataSharing();

      // disable from and to corp if client search box has input, vis versa for client
      this.searchComponent.searchControl.valueChanges.subscribe(input => {
        console.log(input);
        try {
          if (input.length > 0) {
            this.fromCorpComponent.fromCorpControl.setValidators([
              Validators.pattern('[a-zA-Z0-9]*'),
              Validators.maxLength(5),
              Validators.minLength(0),
            ]);
            this.fromCorpComponent.fromCorpControl.updateValueAndValidity();
            // this.fromCorpComponent.fromCorpControl.reset();
            // this.fromCorp = 'null';
            // this.fromCorpComponent.toCorpControl.reset();
            // this.toCorp = 'null';
            // this.fromCorpComponent.fromCorpControl.disable();
            // this.toCorpComponent.toCorpControl.disable();
          } else {
            this.fromCorpComponent.fromCorpControl.setValidators([
              Validators.required,
              Validators.pattern('[a-zA-Z0-9]*'),
              Validators.maxLength(5),
              Validators.minLength(0),
            ]);
            this.fromCorpComponent.fromCorpControl.updateValueAndValidity();
            // this.fromCorpComponent.fromCorpControl.enable();
            // this.toCorpComponent.toCorpControl.enable();
          }
        } catch {
          console.log('input undefined');
        }
      });

      this.fromCorpComponent.fromCorpControl.valueChanges.subscribe(input => {
        console.log(input);
        // try {
        //   if (input.length > 0) {
        //     this.searchComponent.searchControl.reset();
        //     this.searchComponent.searchControl.disable();
        //   } else {
        //     this.searchComponent.searchControl.enable();
        //   }
        // } catch {
        //   console.log('input undefined');
        // }
      });

      this.toCorpComponent.toCorpControl.valueChanges.subscribe(input => {
        console.log(input);
        try {
          if (input.length > 0) {
            this.fromCorpComponent.fromCorpControl.setValidators([
              Validators.required,
              Validators.pattern('[a-zA-Z0-9]*'),
              Validators.maxLength(5),
              Validators.minLength(0),
            ]);
            this.fromCorpComponent.fromCorpControl.updateValueAndValidity();

            // this.searchComponent.searchControl.reset();
            // this.searchComponent.searchControl.disable();
          } else {
            // this.searchComponent.searchControl.enable();
          }
        } catch {
          console.log('input undefined');
        }
      });

      // reset session storage after initialization
      sessionStorage.setItem('templateId', 'null');
      sessionStorage.setItem('templateNm', 'null');
      // session timer startup for detecting session
      this.sessionTimer();
    });
  }

  // stop session timers once the modal is removed
  ngOnDestroy(): void {
    this.sessionTimerService.stopTimers();
  }

  // session timer method for tracking session using mouse movement
  @HostListener('mousemove')
  sessionTimer() {
    this.sessionTimerService.checkSessionStatus();
  }

  // Service calls
  serviceGetTemplateCorps() {
    if (this.data.templateData.templateId !== null
      && this.data.templateData.templateId !== 'null'
      && this.data.templateData.templateId !== '') {

      console.log('in common list corps, what am I passing to service? ' + this.data.moduleName + ' ' + this.data.templateData.templateId);

      // calls the efs api service for this module, in this case for getting all the template corps of this module
      this.efsApiService.callServiceTemplateCorps(this.data.moduleName, this.data.templateData.templateId).subscribe((data: any) => {
        console.log(data);
        if (data !== null) {
          console.log('TEMPLATE CORPS ' + JSON.stringify(data.bsoTemplateDetailList));
          this.bsoTemplateDetailList = data.bsoTemplateDetailList;
          // make a copy
          this.bsoTemplateDetailListCopy = JSON.parse(JSON.stringify(data.bsoTemplateDetailList));
          // create a list of assigned facilities to check against; the remove list cannot have more than what is in this list
          for (const item of this.bsoTemplateDetailListCopy) {
            const facilityIdAndCorp = { facilityId: '', blnktSlsOrderCd: '' };
            facilityIdAndCorp.facilityId = item.facilityId;
            facilityIdAndCorp.blnktSlsOrderCd = item.blnktSlsOrderCd;
            this.assignedFacilitiesToCorpsList.push(facilityIdAndCorp);
          }
          console.log('assigned facility and corp ' + JSON.stringify(this.assignedFacilitiesToCorpsList));

          for (const item of this.bsoTemplateDetailList) { // append the name of the template this corp is associated to
            console.log(JSON.stringify(item));
            item.templateDesc = this.templateDesc;
            // append the facility code to every item based on facility ID
            const facilityObj = this.facilitiesToHold.find(x => x.facilityId === item.facilityId);
            item.facilityCd = facilityObj.facilityCd;
            // console.log('ITEM WITH FACILITY CD ' + JSON.stringify(item));
          }

          this.assocCorpsTable = data.bsoTemplateDetailList;
          this.reusableTable0.dataSource.data = this.bsoTemplateDetailList;

          // get all unique bso ids to identify all pre-associated corps, also get all associated corps for use in searchJson
          for (const item of this.bsoTemplateDetailList) {
            this.bsoCodeAssocIds.push(item.blnktSlsOrderId);
            this.searchJson.associatedCorps.push(item.blnktSlsOrderCd);
          }
          console.log(this.bsoCodeAssocIds);
          console.log(JSON.stringify(this.searchJson));
        }
        this.ref.detectChanges();
      }, error => {
        this.apiErrorHandlingService.errorStatusHandler(error);
      });
      // this.efsApiService.getPreholdTemplateCorps(this.data.templateData.templateId).subscribe((data: any) => {
      //   console.log(data);
      //   if (data !== null) {
      //     console.log('TEMPLATE CORPS ' + JSON.stringify(data.bsoTemplateDetailList));
      //     this.bsoTemplateDetailList = data.bsoTemplateDetailList;
      //     // make a copy
      //     this.bsoTemplateDetailListCopy = JSON.parse(JSON.stringify(data.bsoTemplateDetailList));
      //     // create a list of assigned facilities to check against; the remove list cannot have more than what is in this list
      //     for (const item of this.bsoTemplateDetailListCopy) {
      //       const facilityIdAndCorp = { facilityId: '', blnktSlsOrderCd: '' };
      //       facilityIdAndCorp.facilityId = item.facilityId;
      //       facilityIdAndCorp.blnktSlsOrderCd = item.blnktSlsOrderCd;
      //       this.assignedFacilitiesToCorpsList.push(facilityIdAndCorp);
      //     }
      //     console.log('assigned facility and corp ' + JSON.stringify(this.assignedFacilitiesToCorpsList));

      //     for (const item of this.bsoTemplateDetailList) { // append the name of the template this corp is associated to
      //       item.templateDesc = this.templateDesc;
      //       // append the facility code to every item based on facility ID
      //       const facilityObj = this.facilitiesToHold.find(x => x.facilityId === item.facilityId);
      //       item.facilityCd = facilityObj.facilityCd;
      //       // console.log('ITEM WITH FACILITY CD ' + JSON.stringify(item));
      //     }

      //     this.assocCorpsTable = data.bsoTemplateDetailList;
      //     this.reusableTable0.dataSource.data = this.bsoTemplateDetailList;

      //     // get all unique bso ids to identify all pre-associated corps, also get all associated corps for use in searchJson
      //     for (const item of this.bsoTemplateDetailList) {
      //       this.bsoCodeAssocIds.push(item.blnktSlsOrderId);
      //       this.searchJson.associatedCorps.push(item.blnktSlsOrderCd);
      //     }
      //     console.log(this.bsoCodeAssocIds);
      //     console.log(JSON.stringify(this.searchJson));
      //   }
      // }, error => {
      //   if (error.status === 401) {
      //     if (environment.envName !== 'dev') {
      //       alert('Session is expired and you will be returned to customer center');
      //       sessionStorage.clear();
      //       document.location.href = this.efsApiService.redirectUrl;
      //     }
      //   }
      // });
    } else {
      console.log('No Template Id provided');
    }
  }

  serviceGetClientsByName(userInput) {
    if (userInput.length >= 3) { // get the initial client list
      this.efsApiService.getAllClientsByName(userInput).subscribe((clients: any) => {
        this.clients = clients;
        if (this.clients.length === 0) {
          console.log('empty clients list');
          return;
        }
        this.clientEventSubject.next(clients);
        // console.log(this.clients.length);
      }, error => {
        this.apiErrorHandlingService.errorStatusHandler(error);
      });
    } else { // search on cached list
      const clientList = [];
      for (const item of this.clients) {
        // console.log(JSON.stringify(item.clientNm.toLowerCase().slice(userInput.length)));
        if (item.clientNm.toLowerCase() === userInput.toLowerCase() + item.clientNm.toLowerCase().slice(userInput.length)) {
          clientList.push(item);
        }
      }
      console.log('filtered client list is ' + JSON.stringify(clientList));
      this.clientEventSubject.next(clientList);
    }
  }

  serviceGetCorps(userInput, clientId, fromOrTo) {
    // if (clientId !== null && clientId !== 'null' && clientId !== '') {
    let tempClientId = clientId;
    if (clientId === '' || clientId === undefined || clientId === 'undefined') {
      tempClientId = 'null';
    }
    console.log(this.fromCorpComponent.fromCorpControl.status);
    console.log(this.toCorpComponent.toCorpControl.status);
    if (userInput !== '' && this.fromCorpComponent.fromCorpControl.status === 'VALID' &&
      this.toCorpComponent.toCorpControl.status === 'VALID') { // activating on empty user input, causing error
      this.efsApiService.getAllDistinctCorps(
        userInput,
        tempClientId,
        sessionStorage.getItem('allowedFacilities')).subscribe((data: any) => {
          let corpList = [];
          corpList = data;
          // filter data caused by corps in multiple facilities
          const uniqueArray =
            corpList.filter((object, index) =>
              index === corpList.findIndex(obj => JSON.stringify(obj.blnktSlsOrderCd) === JSON.stringify(object.blnktSlsOrderCd)));
          console.log('filter list ' + JSON.stringify(data));
          if (fromOrTo === true) {
            this.fromEventSubject.next(uniqueArray.slice(0, 101)); // only first 100
          } else {
            this.toEventSubject.next(uniqueArray.slice(0, 101)); // only first 100
          }
        }, error => {
          this.apiErrorHandlingService.errorStatusHandler(error);
        });
    }
  }

  serviceGetTemplateAvailableCorps() {
    if (this.toCorp === '') { // null or empty string is equal to from corp
      this.toCorp = 'null';
    }
    // this.searchJson = {
    //   templateId: '14',
    //   associatedCorps: ['54300'],
    //   targetClientId: null,
    //   disAssociatedFromCorpCd: 'B5437',
    //   disAssociatedToCorpCd: 'B5437'
    // };
    // final check for valid search criteria, if all is null or empty, reject
    if (this.searchJson.disAssociatedFromCorpCd === '' || this.searchJson.disAssociatedFromCorpCd === 'null' &&
      this.searchJson.disAssociatedToCorpCd === '' || this.searchJson.disAssociatedToCorpCd === 'null' &&
      this.searchJson.targetClientId === '' || this.searchJson.targetClientId === 'null') {
      console.log('no valid search criteria, reject');
      // this.popupWarning(false, 'Alert', '');
      this.searchButtonDisable = false;
      // end load screen
      this.hidePage = false;
      this.loadingCorpsBanner = false;
      return;
    }
    // do a seperate check to ensure template id exists
    if (this.searchJson.templateId === '' || this.searchJson.templateId === undefined) {
      this.popupWarning(false, 'Alert', 'Template ID is missing');
      this.searchButtonDisable = false;
      // end load screen
      this.hidePage = false;
      this.loadingCorpsBanner = false;
      return;
    }

    this.efsApiService.callServiceTemplateAvailableCorps(this.data.moduleName, this.searchJson).subscribe((data: any) => {
      this.searchButtonDisable = false;
      // end load screen
      this.hidePage = false;
      this.loadingCorpsBanner = false;

      this.availCorpsTable = [];
      console.log('Template Desc ' + JSON.stringify(data));
      // flatten data for table
      for (const item of data) {
        this.genericizeTemplateName(item); // incoming data field is not generic, make it so
        for (const detailList of item.bsoTemplateDetailList) {
          detailList.templateId = item.templateId;
          detailList.templateDesc = item.templateDesc;
          // add the facility id to the row item
          console.log('before lookup ' + detailList.facilityId);
          detailList.facilityId = this.facilityIdLookup(detailList.facilityCd);
          console.log('after lookup ' + detailList.facilityId);
          if (detailList.templateDesc === undefined) { detailList.templateDesc = ''; } // dont show undefined in table
          this.availCorpsTable.push(detailList);
        }
      }
      // goal is to filter the corps by available facility, remove any corps that are not part of the dropdown list
      // console.log(JSON.stringify(this.availCorpsTable));
      // console.log(JSON.stringify(this.facilitiesToHold));
      this.availCorpsTable = this.availCorpsTable.filter(item => {
        try {
          return this.facilityCds.includes(item.facilityCd);
        } catch { // ie does not support this, so try this instead
          if (this.facilityCds.indexOf(item.facilityCd) !== -1) {
            return true;
          } else { return false; }
        }
      });
      // console.log('post filter ' + JSON.stringify(this.availCorpsTable));
      // console.log('TEMPLATE DESC ' + JSON.stringify(this.availCorpsTable));
      // this.availCorpsTable = this.buildTemplateName(this.availCorpsTable);
      this.reusableTable1.dataSource.data = this.availCorpsTable;
    }, error => {
      this.searchButtonDisable = false;
      // end load screen
      this.hidePage = false;
      this.loadingCorpsBanner = false;
      this.apiErrorHandlingService.errorStatusHandler(error);
    });

    // this.efsApiService.getPreholdTemplateAvailableCorps(this.searchJson).subscribe((data: any) => {
    //   this.availCorpsTable = [];
    //   console.log('Template Desc ' + JSON.stringify(data));
    //   // flatten data for table
    //   for (const item of data) {
    //     for (const detailList of item.bsoTemplateDetailList) {
    //       detailList.templateId = item.templateId;
    //       detailList.templateDesc = item.templateDesc;
    //       // add the facility id to the row item
    //       console.log('before lookup ' + detailList.facilityId);
    //       detailList.facilityId = this.facilityIdLookup(detailList.facilityCd);
    //       console.log('after lookup ' + detailList.facilityId);
    //       if (detailList.templateDesc === undefined) { detailList.templateDesc = ''; } // dont show undefined in table
    //       this.availCorpsTable.push(detailList);
    //     }
    //   }


    //   // console.log('TEMPLATE DESC ' + JSON.stringify(this.availCorpsTable));
    //   // this.availCorpsTable = this.buildTemplateName(this.availCorpsTable);
    //   this.reusableTable1.dataSource.data = this.availCorpsTable;
    // }, error => {
    //   if (error.status === 401) {
    //     if (environment.envName !== 'dev') {
    //       alert('Session is expired and you will be returned to customer center');
    //       sessionStorage.clear();
    //       document.location.href = this.efsApiService.redirectUrl;
    //     }
    //   }
    //   if (error.status === 404) {
    //     alert('404 Not Found, is there a clientID?');
    //   }
    // });
  }

  serviceUpdateTemplate(corpsAdded) {
    this.efsApiService.callServiceUpdateTemplate(this.data.moduleName, corpsAdded).subscribe((data: any) => {
      // Stop loading spiral and save banner
      this.hidePage = false;
      this.savingCorpsBanner = false;

      console.log(data);
      this.popupWarning(false, 'Success', 'Corps have been associated/disassociated');
      this.popupDialogRef.afterClosed().subscribe(result => {
        console.log(result);
        // close the popup if in popup mode
        this.cancelButton();
      });
      this.dataSharingService.shareData('modified');
    }, error => {
      // Stop loading spiral and save banner
      this.hidePage = false;
      this.savingCorpsBanner = false;

      this.saveStatus = false;
      if (error.status === 400 || error.status === 404 || error.status === 500 || error.status === 502) {
        // alert('Bad Request ' + error.error);
        this.popupWarning(false, 'Error', error.error);
      } else {
        this.apiErrorHandlingService.errorStatusHandler(error);
      }
    });


    // this.efsApiService.updatePreholdTemplate(corpsAdded).subscribe((data: any) => {
    //   console.log(data);
    //   this.dataSharingService.shareData('modified');
    //   // close the popup if in popup mode
    //   if (this.showXButton) {
    //     this.cancelButton();
    //   }
    // }, error => {
    //   this.saveStatus = false;
    //   if (error.status === 401) {
    //     if (environment.envName !== 'dev') {
    //       alert('Session is expired and you will be returned to customer center');
    //       sessionStorage.clear();
    //       document.location.href = this.efsApiService.redirectUrl;
    //     }
    //   } else if (error.status === 400) {
    //     alert('Bad Request ' + JSON.stringify(error));
    //   }
    // });
  }

  /**
   * this service will get all facilities based on which module is calling it.
   * for example, plan template module will call getFacilitiesPT.
   */
  serviceGetFacilities() {
    this.efsApiService.callServiceGetFacilities(this.data.moduleName).subscribe((data: any) => {
      console.log(JSON.stringify(data));
      // copy data to original master variable
      this.facilitiesToHold = JSON.parse(JSON.stringify(data));
      // filter out national from facility list
      this.filteredFacilities = data;
      this.filteredFacilities = this.filteredFacilities.filter(x => x.facilityCd !== 'NTL');

      // place the facility codes in a seperate list
      for (const item of this.facilitiesToHold) {
        this.facilityCds.push(item.facilityCd);
      }
      this.facilityControl.setValue(this.allSelectedValue); // set default value
      this.serviceGetTemplateCorps();
      this.hidePage = false;
    },
      error => {
        this.apiErrorHandlingService.errorStatusHandler(error);
      });

    // this.efsApiService.getFacilities().subscribe((data: any) => {
    //   console.log(JSON.stringify(data));
    //   this.facilitiesToHold = data;
    //   this.facilityControl.setValue(this.allSelectedValue); // set default value
    //   this.serviceGetTemplateCorps();
    // },
    //   error => {
    //     this.apiErrorHandlingService.errorStatusHandler(error);
    //   });
  }


  // end of service calls

  filterAssocCorps() {
    this.assocFilterControl.valueChanges.subscribe(input => {
      console.log(input);
      const filteredAssocCorps = [];
      // this.reusableTable0.dataSource.data = this.assocCorpsTable; // update left hand table
      // userInput.toLowerCase() + item.clientNm.toLowerCase().slice(userInput.length)
      for (const item of this.assocCorpsTable) { // match and return look ahead
        if (input.toUpperCase() + item.blnktSlsOrderCd.toUpperCase().slice(input.length) === item.blnktSlsOrderCd) {
          console.log('filter match found');
          filteredAssocCorps.push(item);
        }
      }
      if (filteredAssocCorps.length <= 0) {
        this.reusableTable0.dataSource.data = this.assocCorpsTable; // display ALL
      } else {
        this.reusableTable0.dataSource.data = filteredAssocCorps; // display filtered
      }
    });
  }

  genericizeTemplateName(item) { // genericize incoming template names that belong to each module
    if (this.data.moduleName === 'modulePH') {
      // prehold non generics
      item.templateDesc = item.preholdTemplateDesc;
    } else if (this.data.moduleName === 'moduleDM') {
      // delayed mail non generics

    } else if (this.data.moduleName === 'modulePS') {
      // production setup non-generics

    } else if (this.data.moduleName === 'modulePT') {
      // plan template non-generics
      item.templateDesc = item.planTemplateDesc;
    } else if (this.data.moduleName === 'modulePM') {
      // prod method group non-generics
      item.templateDesc = item.prodmethodgroupTemplateDesc;
    } else if (this.data.moduleName === 'modulePA') {
      // prod method group non-generics

    }
  }

  buildTemplateName(availCorpsTable) { // append template name to top level of array item in order to display in table
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < availCorpsTable.length; i++) {
      // console.log(JSON.stringify(availCorpsTable[i]));
      availCorpsTable[i].TemplateName = '';
      // tslint:disable-next-line:prefer-for-of
      for (let j = 0; j < availCorpsTable[i].templateList.length; j++) {
        // console.log(availCorpsTable[i].templateList.length);
        if (availCorpsTable[i].templateList.length > 0) {
          availCorpsTable[i].TemplateName = availCorpsTable[i].templateList[j].templateDesc;
        }
      }
    }
    console.log('RETURN IS ' + JSON.stringify(availCorpsTable));
    return availCorpsTable;
  }

  compareAlphaNumericCorps(critFromCorp, critToCorp) {
    const fromCorp = critFromCorp;
    const toCorp = critToCorp;

    for (let i = 0; i < fromCorp.length; i++) {
      for (let j = i; j <= i; j++) {
        if (toCorp.charCodeAt(j) < fromCorp.charCodeAt(i)) {
          return false;
        } else if (toCorp.charCodeAt(j) > fromCorp.charCodeAt(i)) {
          return true;
        }
      }
    }
    return true;
  }

  setValues() {
    this.clientId = sessionStorage.getItem('clientId');
    this.clientName = sessionStorage.getItem('clientNm');
    this.clientNameDisp = sessionStorage.getItem('clientNm');
    if (this.clientNameDisp === 'null') {
      this.clientNameDisp = '';
    }
    this.templateDesc = this.data.templateData.templateDesc;
    // this.statesToHold = this.data.templateData.statesToHold;

    // Set search criteria
    this.searchJson.templateId = this.data.templateData.templateId;
    this.searchJson.facilityId = 'null';

    // begin building the body that will be sent to the api
    this.updateListCorps.templateId = this.data.templateData.templateId;
    this.updateListCorps.description = this.data.templateData.templateDesc;
  }

  /**
   * match selected row to item in right side table list, then remove it and move it to next table
   */
  assocCorps() {
    if (this.toggleAsscButton === true) { return; }
    const availCorpItems = []; // save a list of items to remove from the update body
    // for every selected row item, match with table row, delete from table row and add to left hand table

    try {
      for (const selectedItem of this.table1rowData) {
        for (let i = this.availCorpsTable.length - 1; i >= 0; i--) {
          if (this.availCorpsTable[i] === selectedItem) {
            this.availCorpsTable.splice(i, 1);
          }
        }
      }
    } catch {
      console.warn('No row items have been selected');
      return;
    }


    // if bso code appears in bso details list, dont add corps added list; else add to corps added list
    for (const item of this.table1rowData) {
      let isMatch = true;
      try {
        for (const copyItem of this.bsoTemplateDetailListCopy) {
          if (item.blnktSlsOrderCd === copyItem.blnktSlsOrderCd && item.facilityId === copyItem.facilityId) {
            isMatch = true;
            break;
          } else {
            isMatch = false;
          }
        }
      } catch {
        console.log('copy list is empty');
        isMatch = false;
      }
      if (!isMatch) { // if it doesnt exist in the copy list, add to corps added list
        this.updateListCorps.corpsAdded.push(item.blnktSlsOrderCd);
        // console.log('What is being pushed into faclities added? ' + JSON.stringify(item.facilityId));
        this.updateListCorps.facilitiesAdded.push(item.facilityId); // add the facility id as well
      }
    }
    // from the available corps row items list, create a list of actual corps removed
    for (const item of this.table1rowData) {
      console.log('AVAIL CORPS ROW ITEMS ' + JSON.stringify(item));
      try { // catch error when there are no associated corps
        for (const copyItem of this.bsoTemplateDetailListCopy) {
          if (item.blnktSlsOrderCd === copyItem.blnktSlsOrderCd && item.facilityId === copyItem.facilityId) {
            availCorpItems.push(item); // corp being disassociated is currently associated, no net change
          }
        }
      } catch {
        console.log('Currently there are no associated corps');
      }

    }
    // remove from corpsRemoved if the bso code appears in copy list; only if no net change
    try {
      console.log(JSON.stringify(availCorpItems));
      for (const item of availCorpItems) {
        for (let i = this.updateListCorps.corpsRemoved.length - 1; i >= 0; i--) {
          console.log('REMOVE CORPS REMOVED ' + item.blnktSlsOrderCd + ' ' + this.updateListCorps.corpsRemoved[i]);
          if (item.blnktSlsOrderCd === this.updateListCorps.corpsRemoved[i]) {
            this.updateListCorps.corpsRemoved.splice(i, 1);
            break;
          }
        }
      }
    } catch {
      console.log('bsoTemplateDetailsListCopy is empty');
    }

    try {
      // remove from facilities removed list if facility id apperas in copy list
      for (const item of availCorpItems) {
        for (let i = this.updateListCorps.facilitiesRemoved.length - 1; i >= 0; i--) {
          console.log('REMOVE CORPS REMOVED ' + item.facilityId + ' ' + this.updateListCorps.facilitiesRemoved[i]);
          if (item.facilityId === this.updateListCorps.facilitiesRemoved[i]) {
            this.updateListCorps.facilitiesRemoved.splice(i, 1);
            break;
          }
        }
      }
    } catch {
      console.log('bsoTemplateDetailsListCopy is empty');
    }

    console.log('CORPS ADDED ' + JSON.stringify(this.updateListCorps));

    // push every new row to the left hand table
    for (const item of this.table1rowData) {
      this.assocCorpsTable.push(item);
    }
    this.reusableTable0.dataSource.data = this.assocCorpsTable; // update left hand table
    this.reusableTable1.dataSource.data = this.availCorpsTable; // update right hand table
    this.table1rowData = []; // reset the selected data
    // reset checkmarks on lefthand table
    this.reusableTable1.selection.clear();

    this.toggleSaveButton = false;

  }

  /**
   * match selected row to item in left side table list, then remove it and move it to next table
   */
  dissacCorps() {
    if (this.toggleDiscButton === true) { return; } // disabled
    try {
      // for every selected row item, match with table row, delete from table row and add to right hand table
      for (const selectedItem of this.table0rowData) {
        // add to removed list if in copy list, must match corp number as well
        for (const facilityAndCorp of this.assignedFacilitiesToCorpsList) {
          console.log('facility and corp ' + facilityAndCorp.facilityId + ' ' + facilityAndCorp.blnktSlsOrderCd);
          if (selectedItem.facilityId === facilityAndCorp.facilityId && selectedItem.blnktSlsOrderCd === facilityAndCorp.blnktSlsOrderCd) {
            this.updateListCorps.facilitiesRemoved.push(selectedItem.facilityId);
          }
        }
        for (let i = this.assocCorpsTable.length - 1; i >= 0; i--) {
          if (this.assocCorpsTable[i] === selectedItem) {
            this.assocCorpsTable.splice(i, 1);
          }
        }
      }

      console.log('WHAT IS IN TABLE0ROWDATA ' + JSON.stringify(this.table0rowData));
      console.log('WHAT IS IN BSOTEMPLATEDETAILLIST ' + JSON.stringify(this.bsoTemplateDetailListCopy));
      // add corp code to the dissoc list if it is in the bsoTemplateDetailList
      for (const item of this.table0rowData) {
        let isMatch = true;
        try {
          for (const copyItem of this.bsoTemplateDetailListCopy) {
            if (item.blnktSlsOrderCd === copyItem.blnktSlsOrderCd && item.facilityId === copyItem.facilityId) {
              isMatch = true;
              break;
            } else {
              isMatch = false;
            }
          }
        } catch {
          console.log('copy list is empty');
          isMatch = false;
        }
        if (isMatch) { // if it does exist in the copy list, add to corps removed list
          this.updateListCorps.corpsRemoved.push(item.blnktSlsOrderCd);
        }
      }
      // remove from corps added;
      try {
        for (const item of this.bsoTemplateDetailListCopy) {
          for (let i = this.updateListCorps.corpsAdded.length - 1; i >= 0; i--) {
            console.log('REMOVE CORPS added ' + item.blnktSlsOrderCd + ' ' + this.updateListCorps.corpsAdded[i]);
            if (item.blnktSlsOrderCd === this.updateListCorps.corpsAdded[i]) {
              console.log('removed corp ' + item);
              this.updateListCorps.corpsAdded.splice(i, 1);
              break;
            } else {
              // this.updateListCorps.corpsAdded.splice(i, 1);
            }
          }
        }
        // this for loop is for tracking/removing corps that are free agents/not associated - cleanup
        console.log('bsoTemplateDetailListCopy is empty');
        for (const item of this.table0rowData) {
          for (let i = this.updateListCorps.corpsAdded.length - 1; i >= 0; i--) {
            console.log('REMOVE CORPS added ' + item.blnktSlsOrderCd + ' ' + this.updateListCorps.corpsAdded[i]);
            if (item.blnktSlsOrderCd === this.updateListCorps.corpsAdded[i]) {
              console.log('removed corp ' + item);
              this.updateListCorps.corpsAdded.splice(i, 1);
              break;
            } else {
              // this.updateListCorps.corpsAdded.splice(i, 1);
            }
          }
        }
      } catch { // remove from corps added
        console.log('bsoTemplateDetailListCopy is empty');
        for (const item of this.table0rowData) {
          for (let i = this.updateListCorps.corpsAdded.length - 1; i >= 0; i--) {
            console.log('REMOVE CORPS added ' + item.blnktSlsOrderCd + ' ' + this.updateListCorps.corpsAdded[i]);
            if (item.blnktSlsOrderCd === this.updateListCorps.corpsAdded[i]) {
              console.log('removed corp ' + item);
              this.updateListCorps.corpsAdded.splice(i, 1);
              break;
            } else {
              // this.updateListCorps.corpsAdded.splice(i, 1);
            }
          }
        }
      }
      // remove from facilities added list; add to facilities removed list if appears in copy list
      try {
        // for (const item of this.bsoTemplateDetailListCopy) {
        //   for (let i = this.updateListCorps.facilitiesAdded.length - 1; i >= 0; i--) {
        //     console.log('REMOVE CORPS added ' + item.facilityId + ' ' + this.updateListCorps.facilitiesAdded[i]);
        //     if (item.facilityId === this.updateListCorps.facilitiesAdded[i]) {
        //       this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
        //     } else {
        //       // this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
        //     }
        //   }
        // }
        // this for loop is for tracking/removing facil ids that are free agents/not associated - cleanup
        console.log('bsoTemplateDetailListCopy is empty');
        for (const item of this.table0rowData) {
          for (let i = this.updateListCorps.facilitiesAdded.length - 1; i >= 0; i--) {
            console.log('REMOVE CORPS added ' + item.facilityId + ' ' + this.updateListCorps.facilitiesAdded[i]);
            if (item.facilityId === this.updateListCorps.facilitiesAdded[i]) {
              for (const corpItem of this.assocCorpsTable) {
                console.log('corpitem is ' + corpItem.blnktSlsOrderCd);
                if (item.blnktSlsOrderCd === corpItem.blnktSlsOrderCd) {
                  // do nothing
                } else {
                  this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
                  break;
                }
              }
              // this.updateListCorps.facilitiesRemoved.push(item.facilityId); // add to removed list if in copy list
            } else {
              // this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
            }
          }
        }
      } catch { // remove from facilities added
        console.log('bsoTemplateDetailListCopy is empty');
        for (const item of this.table0rowData) {
          for (let i = this.updateListCorps.facilitiesAdded.length - 1; i >= 0; i--) {
            console.log('REMOVE CORPS added ' + item.facilityId + ' ' + this.updateListCorps.facilitiesAdded[i]);
            if (item.facilityId === this.updateListCorps.facilitiesAdded[i]) {
              this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
              break;
              // this.updateListCorps.facilitiesRemoved.push(item.facilityId); // add to removed list if in copy list
            } else {
              // this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
            }
          }
        }
      }

      console.log('CORPS REMOVED ' + JSON.stringify(this.updateListCorps));

      // push every new row to the left hand table
      for (const item of this.table0rowData) {
        this.availCorpsTable.push(item);
      }
      this.reusableTable0.dataSource.data = this.assocCorpsTable; // update left hand table
      this.reusableTable1.dataSource.data = this.availCorpsTable; // update right hand table
      this.table0rowData = []; // reset the selected data
      // reset checkmarks on lefthand table
      this.reusableTable0.selection.clear();
      this.toggleSaveButton = false;
    } catch {
      console.warn('No rows have been selected for disassociation');
    }
  }

  clientSearchButton() {
    // disable search button
    this.searchButtonDisable = true;
    // start load screen and show banner
    this.hidePage = true;
    this.loadingCorpsBanner = true;
    // do not allow search if client and from corp is empty
    if (this.searchComponent.searchControl.value === undefined && this.fromCorpComponent.fromCorpControl.value === '' ||
      this.searchComponent.searchControl.value === '' && this.fromCorpComponent.fromCorpControl.value === '') {
      // alert('Please provide a client or from corp number');
      this.popupWarning(false, 'Alert', 'Please provide a client or from corp number');
      this.searchButtonDisable = false;
      // end load screen
      this.hidePage = false;
      this.loadingCorpsBanner = false;
      return;
    }

    console.log(this.searchComponent.searchControl.value);
    try {
      if (this.searchComponent.searchControl.value.length <= 0) {
        // make sure the corps entered are valid; check only if client is empty
        console.log(this.searchComponent.searchControl.value.length);
        if (this.fromCorpComponent.fromCorpControl.status === 'INVALID' ||
          this.toCorpComponent.toCorpControl.status === 'INVALID') {
          this.openDialog('Invalid Corp Code', 'Please enter a valid corp');
          this.searchButtonDisable = false;
          // end load screen
          this.hidePage = false;
          this.loadingCorpsBanner = false;
          return;
        }
      } else {
        // if from corp is empty, since a client is provided set status to VALID
        if (this.fromCorpComponent.fromCorpControl.value.length <= 0) {
          console.log('did the validators change?');
          this.fromCorpComponent.fromCorpControl.setValidators([
            // Validators.required,
            Validators.pattern('[a-zA-Z0-9]*'),
            Validators.maxLength(5),
            Validators.minLength(0),
          ]);
          this.fromCorpComponent.fromCorpControl.updateValueAndValidity();
        }
        console.log(this.fromCorpComponent.fromCorpControl.status);
        console.log(this.toCorpComponent.toCorpControl.status);
      }
    } catch {
      console.log('did the validators change?');
      this.fromCorpComponent.fromCorpControl.setValidators([
        // Validators.required,
        Validators.pattern('[a-zA-Z0-9]*'),
        Validators.maxLength(5),
        Validators.minLength(0),
      ]);
      this.fromCorpComponent.fromCorpControl.updateValueAndValidity();
    }

    // make sure from corp is creater than to corp
    const fromCorpNo = this.fromCorpComponent.fromCorpControl.value;
    const toCorpNo = this.toCorpComponent.toCorpControl.value;
    console.log('FromCORP ' + fromCorpNo + 'toCORP ' + toCorpNo);
    console.log(this.compareAlphaNumericCorps(fromCorpNo, toCorpNo));
    if (!this.compareAlphaNumericCorps(fromCorpNo, toCorpNo)) {
      this.openDialog('Invalid Corp Code', 'To corp should be greater than from corp');
      this.searchButtonDisable = false;
      // end load screen
      this.hidePage = false;
      this.loadingCorpsBanner = false;
      return;
    }

    if (this.toCorpComponent.toCorpControl.value !== '' ||
      this.toCorpComponent.toCorpControl.value !== null &&
      this.searchComponent.searchControl.value === '') {
      console.log('IS THIS RUNNING?');
      this.fromCorpComponent.fromCorpControl.setValidators([
        Validators.required,
        Validators.pattern('[a-zA-Z0-9]*'),
        Validators.maxLength(5),
        Validators.minLength(0),
      ]);
      this.fromCorpComponent.fromCorpControl.updateValueAndValidity();
      this.fromCorpComponent.fromCorpControl.markAsTouched();
    }

    this.searchJson.targetClientId = this.searchClientId;
    // set the facilities selected for the search
    this.searchJson.facilityId = this.facilityIdSearchValue;
    console.log('VALUE?? ' + this.searchJson.facilityId);

    this.searchJson.disAssociatedFromCorpCd = this.fromCorp;
    if (this.toCorp === 'null' || this.toCorp === '' || this.toCorp === 'NULL') {
      this.searchJson.disAssociatedToCorpCd = this.searchJson.disAssociatedFromCorpCd;
    } else {
      this.searchJson.disAssociatedToCorpCd = this.toCorp;
    }
    // never give null for the range
    try {
      this.searchJson.disAssociatedFromCorpCd = this.fromCorpComponent.fromCorpControl.value.toUpperCase();
      this.searchJson.disAssociatedToCorpCd = this.toCorpComponent.toCorpControl.value.toUpperCase();
    } catch {
      this.searchJson.disAssociatedFromCorpCd = this.fromCorpComponent.fromCorpControl.value;
      this.searchJson.disAssociatedToCorpCd = this.toCorpComponent.toCorpControl.value;
    }


    console.log('FROM CORP AND TO CORP ARE ' + this.searchJson.disAssociatedFromCorpCd + this.searchJson.disAssociatedToCorpCd);

    if (this.searchJson.disAssociatedToCorpCd === '') { // set to equal to from if to is blank
      this.searchJson.disAssociatedToCorpCd = this.searchJson.disAssociatedFromCorpCd;
    }

    // either the range is null when client is provided, or client is null when range is provided
    if (this.searchJson.targetClientId === 'null' ||
      this.searchJson.targetClientId === 'NULL' ||
      this.searchJson.targetClientId === 'undefined'
    ) {
      console.log('IS CONDITION 1 FIRING?');
      this.searchJson.targetClientId = null;
    } else if (this.searchJson.targetClientId !== 'null'
      || this.searchJson.targetClientId !== null) {
      console.log('IS CONDITION 2 FIRING?');
      // this.searchJson.disAssociatedToCorpCd = 'null';
      // this.searchJson.disAssociatedFromCorpCd = 'null';
    }

    console.log(JSON.stringify(this.searchJson));

    if (this.searchJson.targetClientId !== 'null' && this.searchJson.targetClientId !== null) { // cannot search if the client doesnt exist
      if (this.fromCorpComponent.fromCorpControl.status === 'VALID') {
        if (this.searchJson.disAssociatedFromCorpCd === '') {
          this.searchJson.disAssociatedFromCorpCd = 'null';
        }
        if (this.searchJson.disAssociatedToCorpCd === '') {
          this.searchJson.disAssociatedToCorpCd = 'null';
        }
        this.serviceGetTemplateAvailableCorps();
      } else if (this.fromCorpComponent.fromCorpControl.disabled && this.fromCorpComponent.fromCorpControl.status !== 'INVALID') {
        this.serviceGetTemplateAvailableCorps();
      } else {
        // alert('Please provide a corp range or Client name');
        this.popupWarning(false, 'Alert', 'Please provide a corp range or Client name');
        // end load screen
        this.hidePage = false;
        this.loadingCorpsBanner = false;
        this.searchButtonDisable = false;
      }
    } else if (this.searchJson.disAssociatedFromCorpCd !== 'null' &&
      this.searchJson.disAssociatedFromCorpCd !== null &&
      this.fromCorpComponent.fromCorpControl.status === 'VALID') {
      this.serviceGetTemplateAvailableCorps();

    } else {
      console.log('no corps exist with that name');
      this.searchButtonDisable = false;
      // end load screen
      this.hidePage = false;
      this.loadingCorpsBanner = false;

      this.fromCorpComponent.fromCorpControl.markAsTouched();
      this.availCorpsTable = []; // clear the cache
      this.reusableTable1.dataSource.data = []; // reset the table bad info was entered
    }
  }

  /**
   * this method will do the final rule determination for sorting the left hand table into the various
   * lists that will be sent back to the backend. 3 rule system
   */
  submitProcessing() {
    console.log(JSON.stringify(this.updateListCorps));
    console.log(JSON.stringify(this.assignedFacilitiesToCorpsList));

    // make a copy of the left hand side table
    let associatedCorpsTableCopy = [];
    associatedCorpsTableCopy = JSON.parse(JSON.stringify(this.assocCorpsTable));
    console.log('what is the assoc corps table copy? ' + JSON.stringify(associatedCorpsTableCopy));
    // make a copy of the assigned corps list
    let assignedFacilitiesToCorpsListCopy = [];
    assignedFacilitiesToCorpsListCopy = JSON.parse(JSON.stringify(this.assignedFacilitiesToCorpsList));
    console.log('what is the assigned corps copy? ' + JSON.stringify(assignedFacilitiesToCorpsListCopy));

    this.updateListCorps.corpsRemoved = [];
    this.updateListCorps.corpsAdded = [];
    // this.updateListCorps.detailsUpdated = [];
    // this.updateListCorps.detailsRemoved = [];
    // this.updateListCorps.detailsAdded = [];
    this.updateListCorps.facilitiesAdded = [];
    this.updateListCorps.facilitiesRemoved = [];

    try {
      for (let i = associatedCorpsTableCopy.length - 1; i >= 0; i--) {
        console.log(associatedCorpsTableCopy[i].blnktSlsOrderCd);
        for (const assocItems of this.assignedFacilitiesToCorpsList) {
          console.log('why is it undefined? ' + associatedCorpsTableCopy[i].blnktSlsOrderCd + ' ' + assocItems.blnktSlsOrderCd +
            associatedCorpsTableCopy[i].facilityId + ' ' + assocItems.facilityId);
          // rule 1 if it exists in assoc corps table and assignedfacil lists, it already is assoc and can be discarded
          if (associatedCorpsTableCopy[i].blnktSlsOrderCd === assocItems.blnktSlsOrderCd &&
            associatedCorpsTableCopy[i].facilityId === assocItems.facilityId) {
            console.log('splicing');
            associatedCorpsTableCopy.splice(i, 1); // remove the item, it is already associated
            break;
          }
        }
      }
    } catch {
      console.log('associatedCorpsTableCopy is empty');
    }
    // what is left is what will be associated
    console.log('whats left? ' + JSON.stringify(associatedCorpsTableCopy));

    /**
     * // check checklist against the left hand side table, if the checklist value does not appear in the left hand side table,
     * it has been dissasasociated and should be added to the dissoc list for removal
     */
    try {
      for (let i = assignedFacilitiesToCorpsListCopy.length - 1; i >= 0; i--) {
        console.log(assignedFacilitiesToCorpsListCopy[i].blnktSlsOrderCd);
        for (const leftTableItem of this.assocCorpsTable) {
          console.log('why is it undefined? ' + assignedFacilitiesToCorpsListCopy[i].blnktSlsOrderCd + ' ' + leftTableItem.blnktSlsOrderCd +
            assignedFacilitiesToCorpsListCopy[i].facilityId + ' ' + leftTableItem.facilityId);
          // rule 1 if it exists in assoc corps table and assignedfacil lists, it already is assoc and can be discarded
          if (assignedFacilitiesToCorpsListCopy[i].blnktSlsOrderCd === leftTableItem.blnktSlsOrderCd &&
            assignedFacilitiesToCorpsListCopy[i].facilityId === leftTableItem.facilityId) {
            console.log('splicing');
            assignedFacilitiesToCorpsListCopy.splice(i, 1); // remove the item, it is already associated
            break;
          }
        }
      }
    } catch {
      console.log('assignedFacilitiesToCorpsListCopy is empty');
    }
    // whats left is what will be disasociated from the template
    console.log('whats left of assignedFacilitiesToCorpsListCopy ' + JSON.stringify(assignedFacilitiesToCorpsListCopy));

    // send the results into their proper payload lists for final delivery
    for (const corpItem of associatedCorpsTableCopy) {
      console.log(JSON.stringify(corpItem));
      this.updateListCorps.corpsAdded.push(corpItem.blnktSlsOrderCd);
      this.updateListCorps.facilitiesAdded.push(corpItem.facilityId);
    }
    for (const corpItem of assignedFacilitiesToCorpsListCopy) {
      console.log(JSON.stringify(corpItem));
      this.updateListCorps.corpsRemoved.push(corpItem.blnktSlsOrderCd);
      this.updateListCorps.facilitiesRemoved.push(corpItem.facilityId);
    }
    console.log('update list corps ' + JSON.stringify(this.updateListCorps));


  }

  saveButton() { // set any array that has no values to null


    console.log('SAVE BUTTON ' + JSON.stringify(this.updateListCorps));
    this.toggleSaveButton = true; // immediately disable save button in case of duplicates
    let AsscCorps = this.updateListCorps.corpsAdded;
    let DiscCorps = this.updateListCorps.corpsRemoved;

    this.submitProcessing();

    if (AsscCorps === null) { AsscCorps = ['None']; } // display none instead of null
    if (DiscCorps === null) { DiscCorps = ['None']; }
    this.popupWarning(true, '', 'For this template: ' + this.templateDesc + '\n\n' + 'Associated corps: '
      + AsscCorps + '\n\n' + 'Disassociated corps: ' + DiscCorps);

    this.popupDialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // start loading spiral and save banner
        this.hidePage = true;
        this.savingCorpsBanner = true;

        console.log('YES');
        if (this.updateListCorps.corpsRemoved.length === 0) {
          this.updateListCorps.corpsRemoved = null;
        }
        if (this.updateListCorps.corpsAdded.length === 0) {
          this.updateListCorps.corpsAdded = null;
        }
        if (this.updateListCorps.detailsUpdated.length === 0) {
          this.updateListCorps.detailsUpdated = null;
        }
        if (this.updateListCorps.detailsRemoved.length === 0) {
          this.updateListCorps.detailsRemoved = null;
        }
        if (this.updateListCorps.detailsAdded.length === 0) {
          this.updateListCorps.detailsAdded = null;
        }
        if (this.updateListCorps.facilitiesAdded.length === 0) {
          this.updateListCorps.facilitiesAdded = null;
        }
        if (this.updateListCorps.facilitiesRemoved.length === 0) {
          this.updateListCorps.facilitiesRemoved = null;
        }

        console.log(JSON.stringify(this.updateListCorps));
        this.serviceUpdateTemplate(this.updateListCorps);
        this.toggleSaveButton = !this.toggleSaveButton;
        this.toggleAsscButton = !this.toggleAsscButton;
        this.toggleDiscButton = !this.toggleDiscButton;
        this.saveOccured = true;
        this.saveStatus = true;
      } else {
        this.toggleSaveButton = false;
        console.log('NO');
        // Stop loading spiral and save banner
        this.hidePage = false;
        this.savingCorpsBanner = false;
      }
    });
  }

  cancelButton() {
    // restore the template id in session storage when returning properly
    sessionStorage.setItem('templateId', this.data.templateData.templateId);
    // this.dialogRef.close();
    window.close();
  }

  popupWarning(questionType, title?, message?) {
    this.popupDialogRef = this.dialog.open(GenericPopupComponent, {
      // minWidth: '300px',
      maxWidth: 'auto',
      maxHeight: 'auto',
      panelClass: 'popup-borders',
      data: {
        questionType,
        textAreaText: true,
        title,
        message
      }
    });
    return true;
    // return finalResult;
  }

  openDialog(title, message) {
    const dialogRef = this.dialog.open(GenericPopupComponent, {
      width: '450px',
      data: {
        message,
        title
      },
      maxWidth: '500px',
      maxHeight: '500px',
      panelClass: 'popup-borders'
    });
  }

  loadTableComponent() { // load table component features and preliminary data
    // read only vs view only mode
    if (sessionStorage.getItem('listCorpView') === 'viewOnly') {
      this.columns = [
        { columnDef: 'blnktSlsOrderCd', header: 'Corp', cell: (element: any) => `${element.blnktSlsOrderCd}` },
        { columnDef: 'facilityCd', header: 'Facility', cell: (element: any) => `${element.facilityCd}` },
        { columnDef: 'blnktSlsOrderDesc', header: 'Description', cell: (element: any) => `${element.blnktSlsOrderDesc}` },
        { columnDef: 'clientNm', header: 'Client', cell: (element: any) => `${element.clientNm}` },
      ];
      this.displayedColumns = this.columns.map(c => c.columnDef);
      this.reusableTable0.disableCheckboxesColumn = true;
    } else {
      this.reusableTable0.disableCheckboxesColumn = false;
    }
    // this.reusableTable0.disableIndexColumn = false;
    // this.reusableTable0.enableSelectableRows = true;
    this.reusableTable0.matTooltip = 'Select a corp to disassociate';
    // this.reusableTable0.dataSource.data = [{
    //   'blnktSlsOrderCd': 'corp',
    //   'blnktSlsOrderDesc': 'detail', 'clientNm': 'client1'
    // },
    // { 'blnktSlsOrderCd': 'corp2', 'blnktSlsOrderDesc': 'detail', 'clientNm': 'client2' }];

    this.reusableTable1.disableCheckboxesColumn = false;
    // this.reusableTable1.disableIndexColumn = false;
    // this.reusableTable1.enableSelectableRows = true;
    this.reusableTable1.matTooltip = 'Select a corp to associate';
  }

  loadToCorpComponent() {
    this.toCorpComponent.fromElement = false;
  }

  updateBsoCodes(tableRowData) {
    // add bso code to the corps removed array in updateListCorps
    let matchFound = false;
    if (this.updateListCorps.corpsRemoved.length === 0) {
      this.updateListCorps.corpsRemoved.push(tableRowData.blnktSlsOrderCd);
      console.log('UPDATE LIST CORPS REMOVED ' + JSON.stringify(this.updateListCorps.corpsRemoved));
    } else {
      for (const item of this.updateListCorps.corpsRemoved) {
        if (item === tableRowData.blnktSlsOrderCd) {
          console.log(item);
          console.log(tableRowData.blnktSlsOrderCd);
          matchFound = true;
        }
      }
      if (!matchFound) {
        this.updateListCorps.corpsRemoved.push(tableRowData.blnktSlsOrderCd);
        console.log('UPDATE LIST CORPS REMOVED ' + JSON.stringify(this.updateListCorps.corpsRemoved));
      }
    }
  }

  // methods for getting data from reusable components
  receiveMessage($event) {
    this.message = $event;
    console.log('I RECEIVED func0 ' + JSON.stringify(this.message));
  }

  table1ReceiveMessage($event) {
    this.table1rowData = $event;
    console.log('I RECEIVED func1 ' + JSON.stringify(this.table1rowData));
  }

  table0ReceiveMessage($event) {
    this.table0rowData = $event;
    console.log('I RECEIVED func2 ' + JSON.stringify(this.table0rowData));
  }

  fromReceiveMessage($event) {
    if (typeof $event === 'object') {
      this.fromCorp = $event.blnktSlsOrderCd;
    } else {
      this.fromCorp = $event;
    }
    console.log('FROM SEARCH RECEIVED ' + JSON.stringify(this.fromCorp));
    this.serviceGetCorps(this.fromCorp, this.searchClientId, true);
  }

  toReceiveMessage($event) {
    if (typeof $event === 'object') {
      this.toCorp = $event.blnktSlsOrderCd;
    } else {
      this.toCorp = $event;
    }
    console.log('TO SEARCH RECEIVED ' + JSON.stringify(this.toCorp));
    this.serviceGetCorps(this.toCorp, this.searchClientId, false);
  }

  searchReceiveMessage($event) {
    this.searchMessage = $event;
    console.log('CLIENT SEARCH RECEIVED ' + JSON.stringify(this.searchMessage));
    console.log(this.searchComponent.searchControl.status);
    if (this.searchComponent.searchControl.status !== 'INVALID') {
      this.serviceGetClientsByName(this.searchMessage);
    }
    // this.serviceGetClientsByName(this.searchMessage);
  }

  receiveMessageObj($event) { // assigns client id and client name
    this.messageObject = $event;
    console.log(JSON.stringify('RECEIVE MESSAGE OBJECT ' + JSON.stringify(this.messageObject)));
    try {
      if (this.messageObject.clientId.length <= 0 || this.messageObject.clientNm.length <= 0) {
        console.log('return was undefined, length of zero');
        this.searchClientId = 'null';
        this.clientName = 'null';
      } else {
        console.log('return was good');
        this.searchClientId = this.messageObject.clientId;
        this.clientName = this.messageObject.clientNm;
      }
    } catch {
      console.log('return was undefined, caught');
      this.searchClientId = 'null';
      this.clientName = 'null';
    }
    // this.searchClientId = this.messageObject.clientId;
    // this.clientName = this.messageObject.clientNm;
  }
  // end of getting data methods

  // facilities methods
  selectAll() {
    // this.toggleAllSelected = !this.toggleAllSelected;
    this.selectedFacilityId = null;
    this.facilityIdSearchValue = null;
    if (this.toggleAllSelected === true) {
      this.facilityIds = ['null'];
      // sessionStorage.setItem('facilityIds', 'null');
      // enable material
      // this.materialControl.enable();
      // this.serviceGetInsertDetails('00050837', this.facilityIds);
    } else {
      this.facilityIds = [];
      // this.materialControl.disable();
    }
    console.log(this.facilityControl.value);
  }

  facilityIdLookup(value, isClicked?) {
    console.log(isClicked);
    console.log('STATEIDLOOKUP ' + JSON.stringify(value));
    const facilityObject = value.toLowerCase();
    // find the state id, put it into array if it its not there (aka checked)
    for (const facility of this.facilitiesToHold) {
      if (
        facilityObject === facility.facilityId.toLowerCase() ||
        facilityObject === facility.facilityNm.toLowerCase() ||
        facilityObject === facility.facilityCd.toLowerCase()
      ) {
        const id = this.facilityIds.find(x => x === facility.facilityId);
        this.selectedFacilityId = id;
        if (isClicked === 'true') { // this value should not be affected by the search
          this.facilityIdSearchValue = id;
        }
        if (id === undefined) {
          this.selectedFacilityId = facility.facilityId;
          if (isClicked === 'true') {
            this.facilityIdSearchValue = facility.facilityId;
          }
          this.facilityIds.push(facility.facilityId);
          // remove id if it is already in the array (aka unchecked)
        } else {
          console.log('X IS ' + id);
          const index = this.facilityIds.indexOf(id);
          // console.log('INDEX IS ' + index);
          this.facilityIds.splice(index, 1);
        }
      }
    }
    console.log('FACILITY CODES IS ' + this.facilityIds);
    const facilityIds = this.facilityIds.join('-');
    // sessionStorage.setItem('facilityIds', facilityIds);
    if (this.facilityIds.length === 0) {
      // this.materialControl.disable();
    } else {
      // this.materialControl.enable();
      // this.serviceGetInsertDetails('00050837', this.facilityIds);
    }
    return this.selectedFacilityId;
  }
  // end of facilities methods

  // this method gets the non-generic key name and sets it to be generic. when outgoing will switch back to non-generic
  genericizeData() {
    if (this.data.moduleName === 'modulePH') {
      // prehold non generics
      this.data.templateData.templateId = this.data.templateData.preholdTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.preholdTemplateDesc;
      if (this.data.templateData.templateId === '') { this.popupWarning(false, 'Alert', 'missing template ID'); }
    } else if (this.data.moduleName === 'moduleDM') {
      // delayed mail non generics
      this.data.templateData.templateId = this.data.templateData.delayedmailTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.delayedmailTemplateDesc;
    } else if (this.data.moduleName === 'modulePS') {
      // production setup non-generics
      this.data.templateData.templateId = this.data.templateData.productionTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.productionTemplateDesc;
    } else if (this.data.moduleName === 'modulePT') {
      // plan template non-generics
      this.data.templateData.templateId = this.data.templateData.planTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.planTemplateDesc;
    } else if (this.data.moduleName === 'modulePM') {
      // prod method group non-generics
      this.data.templateData.templateId = this.data.templateData.prodmethodgroupTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.prodmethodgroupTemplateDesc;
    } else if (this.data.moduleName === 'modulePA') {
      // prod method group non-generics
      this.data.templateData.templateId = this.data.templateData.packageTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.packageTemplateDesc;
    }
  }

  downloadCsv() {
    // make new json with flattened selected values
    const copyItems = [];
    let items = [];
    items = this.reusableTable0.dataSource.data;
    for (const item of items) {
      const tempObj = {
        Corp: '',
        Facility: '',
        Description: '',
        Client: '',
      };
      tempObj.Corp = item.blnktSlsOrderCd;
      tempObj.Facility = item.facilityCd;
      tempObj.Description = item.blnktSlsOrderDesc;
      tempObj.Client = item.clientNm;
      copyItems.push(tempObj);
    }
    console.log(JSON.stringify(copyItems));

    // convert json to csv
    const replacer = (key, value) => value === null ? '' : value;
    const header = Object.keys(copyItems[0]);
    const csv = copyItems.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    // csv.unshift('sep=,');
    // csv.unshift({Template: this.templateDesc}); // place the tempalte name within the csv
    let finalCsv = JSON.stringify(csv);
    finalCsv = csv.join('\r\n');
    console.log(finalCsv);
    finalCsv = finalCsv.replace(/\\"/g, '""');
    finalCsv = 'Template: ' + this.templateDesc + '\n' + finalCsv;
    const csvFile = finalCsv;
    console.log(finalCsv);

    const blob = new Blob([csvFile], { type: 'text/csv' });
    saveAs(blob, 'Table.csv');
  }
}
